import { Box, Typography } from '@mui/material';
import { type ApprovalOddsValues, Likelihood } from './constants';
type CardsApprovalLabelProps = {
  approvalLikelihood: ApprovalOddsValues;
  desktopStyle?: boolean;
};
export const CardsApprovalLabel = ({
  approvalLikelihood,
  desktopStyle
}: CardsApprovalLabelProps) => {
  const {
    color,
    label,
    desktopDelta,
    labelDelta
  } = approvalLikelihood;
  const isExcellent = label === Likelihood.Excellent;
  const delta = (desktopStyle ? desktopDelta : labelDelta) ?? 0;
  return <Box data-testid="approval-label" display="block" whiteSpace="nowrap" borderRadius={1} paddingY={1} width={isExcellent ? '6.5rem' : '4.5rem'} color={theme => theme.palette.common.white} bgcolor={color} zIndex={999} sx={theme_0 => ({
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '0.625rem',
      height: '0.625rem',
      bgcolor: color,
      transform: 'rotate(45deg)',
      left: `${45 + labelDelta}%`,
      bottom: '-0.25rem',
      [theme_0.breakpoints.up('md')]: {
        left: isExcellent && !desktopStyle ? '45%' : `${45 + delta}%`
      }
    }
  })}>
      <Typography variant="accentSmall" fontSize="13px">
        {label}
      </Typography>
    </Box>;
};